import React from 'react';
import Div from './components/Div.styled';
import LandingPage from './landing/surveyLanding';

type Props = {
  surveyLandingUrl?: string;
};

const Survey: React.FC<Props> = ({
  surveyLandingUrl = '/en/hybrid-and-electric/survey-results.html/start',
}) => {
  return (
    <Div>
      <Div
        padding="100px 0 0 0"
        customStyles={{
          position: 'relative',
          paddingBottom: 160,
        }}
      >
        <LandingPage surveyLandingUrl={surveyLandingUrl} />
      </Div>
    </Div>
  );
};

export default Survey;
